import { useParams, useNavigate } from 'react-router-dom';
import { publicApi } from '../lib/api';
import { SetPasswordForm } from './AcceptInvite';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  return (
    <SetPasswordForm
      heading="Reset your password"
      intro="Choose a new password for your 5 River Roofing account."
      submitLabel="Save new password"
      onSubmit={async (password) => {
        await publicApi.post('/users/reset-password', { token, password });
        navigate('/login', { replace: true });
      }}
    />
  );
}
